import styled from 'styled-components';

export default function getParsedReview(text, styles = {}, reviewSpanList = []) {
  if (!text || text === null || text === 'null') {
    return null;
  }

  reviewSpanList.sort((a, b) => a[0] - b[0]); // Ensure ranges are sorted

  const comp = [];

  if (reviewSpanList.length) {
    // Process using reviewSpanList
    let lastIndex = 0;

    reviewSpanList.forEach(([start, end]) => {
      // Ensure indices are within bounds of text length
      if (start >= text.length) return; // Ignore spans starting outside of text
      if (end > text.length) end = text.length; // Adjust end index if it exceeds text length

      // Text before the bold section
      if (lastIndex < start) {
        comp.push(
          <RecentReviewDetails font={styles.fontSize}>
            {text.slice(lastIndex, start)}
          </RecentReviewDetails>,
        );
      }

      // Bold text
      comp.push(
        <RecentReviewDetails className="active" font={styles.fontSize}>
          {text.slice(start, end)}
        </RecentReviewDetails>,
      );
      lastIndex = end;
    });

    // Add remaining text after the last bold section
    if (lastIndex < text.length) {
      comp.push(
        <RecentReviewDetails font={styles?.fontSize}>{text.slice(lastIndex)}</RecentReviewDetails>,
      );
    }
  } else {
    // Process using <b> and </b> tags
    const openTag = '<b>';
    const closeTag = '</b>';
    const splitArray = text.split(openTag);

    if (splitArray[0].indexOf(closeTag) === -1) {
      if (splitArray[0]) {
        comp.push(
          <RecentReviewDetails font={styles?.fontSize}>{splitArray[0]}</RecentReviewDetails>,
        );
      }
      splitArray.shift();
    }

    splitArray.forEach(txt => {
      const secondSplit = txt.split(closeTag);
      if (secondSplit[0]) {
        comp.push(
          <RecentReviewDetails className="active" font={styles?.fontSize}>
            {secondSplit[0]}
          </RecentReviewDetails>,
        );
      }
      if (secondSplit[1]) {
        comp.push(
          <RecentReviewDetails font={styles?.fontSize}>{secondSplit[1]}</RecentReviewDetails>,
        );
      }
    });
  }

  return comp.length ? (
    <RecentReviewDetails font={styles.fontSize}>{comp}</RecentReviewDetails>
  ) : null;
}

const RecentReviewDetails = styled.span(
  props => `
  font-size: ${props?.font || props.theme.font.custom(14)};
  &.active {
    font-weight: 600;
  }
  `,
);
